module.exports = __webpack_public_path__ + "media/student_contributors/07LaurenRabold-8b349780.png";